export const nace_2 = [
  {
    value: "Crop and animal production, hunting and related service activities",
  },
  { value: "Forestry and logging" },
  { value: "Fishing and aquaculture" },
  { value: "Mining of coal and lignite" },
  { value: "Extraction of crude petroleum and natural gas" },
  { value: "Mining of metal ores" },
  { value: "Other mining and quarrying" },
  { value: "Mining support service activities" },
  { value: "Manufacture of food products" },
  { value: "Manufacture of beverages" },
  { value: "Manufacture of tobacco products" },
  { value: "Manufacture of textiles" },
  { value: "Manufacture of wearing apparel" },
  { value: "Manufacture of leather and related products" },
  {
    value:
      "Manufacture of wood and of products of wood and cork, except furniture; manufacture of articles of straw and plaiting materials",
  },
  { value: "Manufacture of paper and paper products" },
  { value: "Printing and reproduction of recorded media" },
  { value: "Manufacture of coke and refined petroleum products" },
  { value: "Manufacture of chemicals and chemical products" },
  {
    value:
      "Manufacture of basic pharmaceutical products and pharmaceutical preparations",
  },
  { value: "Manufacture of rubber and plastic products" },
  { value: "Manufacture of other non metallic mineral products" },
  { value: "Manufacture of basic metals" },
  {
    value:
      "Manufacture of fabricated metal products, except machinery and equipment",
  },
  { value: "Manufacture of computer, electronic and optical products" },
  { value: "Manufacture of electrical equipment" },
  { value: "Manufacture of machinery and equipment n.e.c." },
  { value: "Manufacture of motor vehicles, trailers and semi trailers" },
  { value: "Manufacture of other transport equipment" },
  { value: "Manufacture of furniture" },
  { value: "Other manufacturing" },
  { value: "Repair and installation of machinery and equipment" },
  { value: "Electricity, gas, steam and air conditioning supply" },
  { value: "Water collection, treatment and supply" },
  { value: "Sewerage" },
  {
    value:
      "Waste collection, treatment and disposal activities; materials recovery",
  },
  { value: "Remediation activities and other waste management services" },
  { value: "Construction of buildings" },
  { value: "Civil engineering" },
  { value: "Specialised construction activities" },
  {
    value:
      "Wholesale and retail trade and repair of motor vehicles and motorcycles",
  },
  { value: "Wholesale trade, except of motor vehicles and motorcycles" },
  { value: "Retail trade, except of motor vehicles and motorcycles" },
  { value: "Land transport and transport via pipelines" },
  { value: "Water transport" },
  { value: "Air transport" },
  { value: "Warehousing and support activities for transportation" },
  { value: "Postal and courier activities" },
  { value: "Accommodation" },
  { value: "Food and beverage service activities" },
  { value: "Publishing activities" },
  {
    value:
      "Motion picture, video and television programme production, sound recording and music publishing activities",
  },
  { value: "Programming and broadcasting activities" },
  { value: "Telecommunications" },
  { value: "Computer programming, consultancy and related activities" },
  { value: "Information service activities" },
  {
    value: "Financial service activities, except insurance and pension funding",
  },
  {
    value:
      "Insurance, reinsurance and pension funding, except compulsory social security",
  },
  {
    value:
      "Activities auxiliary to financial services and insurance activities",
  },
  { value: "Real estate activities" },
  { value: "Legal and accounting activities" },
  { value: "Activities of head offices; management consultancy activities" },
  {
    value:
      "Architectural and engineering activities; technical testing and analysis",
  },
  { value: "Scientific research and development" },
  { value: "Advertising and market research" },
  { value: "Other professional, scientific and technical activities" },
  { value: "Veterinary activities" },
  { value: "Rental and leasing activities" },
  { value: "Employment activities" },
  {
    value:
      "Travel agency, tour operator and other reservation service and related activities",
  },
  { value: "Security and investigation activities" },
  { value: "Services to buildings and landscape activities" },
  {
    value:
      "Office administrative, office support and other business support activities",
  },
  { value: "Public administration and defence; compulsory social security" },
  { value: "Education" },
  { value: "Human health activities" },
  { value: "Residential care activities" },
  { value: "Social work activities without accommodation" },
  { value: "Creative, arts and entertainment activities" },
  { value: "Libraries, archives, museums and other cultural activities" },
  { value: "Gambling and betting activities" },
  { value: "Sports activities and amusement and recreation activities" },
  { value: "Activities of membership organisations" },
  { value: "Repair of computers and personal and household goods" },
  { value: "Other personal service activities" },
  { value: "Activities of households as employers of domestic personnel" },
  {
    value:
      "Undifferentiated goods  and services producing activities of private households for own use",
  },
  { value: "Activities of extraterritorial organisations and bodies" },
];
